import { ChangeDetectorRef, Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ProgressReportHttpCallsService } from '../progress-report-http-calls.service';
import { ProgressReportPageComponent } from '../progress-report-page/progress-report-page.component';
import { environment } from 'src/environments/environment';
import { StudentProgressReportComponent } from '../student-progress-report/student-progress-report.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-employee-student-progress-report',
  templateUrl: './employee-student-progress-report.component.html',
  styleUrls: ['./employee-student-progress-report.component.scss']
})
export class EmployeeStudentProgressReportComponent implements OnInit {
  @ViewChild('StudentProgressReportComponent') childComponent!: StudentProgressReportComponent;
  scaitsWebServiceUrl: any = environment.employeeURL + "/jwtV2/api/employee"
  report: any;
  studentreport: any;
  showComponent: boolean = false;
  count: any = 0;
  notfirstTime:boolean=false;
  body: any;
  constructor(private service: ProgressReportHttpCallsService,  private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    // localStorage.setItem('studentUniqueRefNo',"qiC5udHzVRB03LI5nuRsnw==")
    localStorage.setItem('url', environment.employeeURL + "/jwtV2/api/employee")
    this.report = new ProgressReportPageComponent(this.service)
    this.studentreport = new StudentProgressReportComponent(this.service,this.spinner)
   this.body= document.getElementById("body")
   this.body!.style.backgroundColor="white";
  }
  search() {
    const value = $("#input").val()!.toString();
    if (value.length >= 5) {

      const data = {
        "admNo": 0,
        "businessType": "COLLEGE",
        "mobileNo": 0,
        "pageCount": 0,
        "parentName": "",
        "searchKey": $("#input").val()?.toString(),
        "stdName": ""
      }
      this.spinner.show();
      this.body!.style.backgroundColor="#f5f5f5";
      this.service.studentSearch("", this.scaitsWebServiceUrl, data).subscribe((res: any) => {
        if (res) {

          this.showComponent = true;
          // console.log(res[0].stdUniqueRefId)
          this.studentreport!.studentDetails(res[0].stdUniqueRefId)
          localStorage.setItem('studentUniqueRefNo', res[0].stdUniqueRefId)
          if (this.count != 0) {
            this.childComponent!.studentDetails(res[0].stdUniqueRefId);
          }
          this.count++;

        }
        else {
          this.showComponent = false;
          this.notfirstTime=true;
          this.body!.style.backgroundColor="white";
          // window.alert("Please enter correct admisson number")
        }
        this.spinner.hide();
      });
    }
    else {
      this.showComponent = false;
      // window.alert("please enter valid admission number")
    }
  }
}
